/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useState } from 'react';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getIconPath, routerPush, parseBoolean, getViewportInfo } from '@tcp/core/src/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getAPIConfig, isCanada } from '@tcp/core/src/utils/utils';
import AddedtoBagDynamicStore from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBagDynamicStore.js';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import { getZoneOneBadgesArray } from '@tcp/core/src/utils/badge.util';
import {
  extractAttributeValue,
  getInfluencerTags,
  getInfluencerPicks,
} from '@tcp/core/src/services/abstractors/productListing/productParser';
import {
  callAnalyticsOnAddToBagclick,
  updateGoogleAnalyticsData,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/container/analyticsHelper.js';
import {
  renderColorSwatches,
  renderZoneSixBadges,
  renderBadge,
  renderSubmitButton,
  renderPointsAndPromotion,
} from './SlpTileItemComponents';
import getImageData from './plpTileHelpers/imageDataHelper';
import getPlpTileBadges from './plpTileHelpers/plpTileBadgesHelper';
import {
  getTCPPrimaryCategory,
  handleClickFunc,
  handleMouseEnterImage,
  handleMouseLeaveImage,
  getMountedTileRedesignVariation,
  calculateMinPrices,
  getBadgeLabels,
  getSwatches,
  getAlternateBrand,
  getInfluencersPickToDisplay,
  getRelatedSwatches,
  getTileHoverProps,
  getSLPTileLabels,
  getInteractiveColorSwatchesClass,
  getIsMountedHoverToRevealATBButtonEnabled,
} from './plpTileHelpers/slpTileHelper';
import { AtbIcon } from './styles/SubmitButton.style';
import {
  extractBaseUrl,
  getImageAssetConfig,
  getPdpUrlWithAlternateBrandSLP,
  getPlpProductBrand,
  isBundleProduct,
  getProductDataForPdp,
} from './plpTileHelpers/plpTileCommonHelpers';
import PriceAndWishList from './PriceAndWishList';
import Wishlist from './Wishlist';
import Price from './Price';
import ProductImage from './ProductImage';
import ProductTitleAndBrand from './ProductTitleAndBrand';
import PromotionView from './Promotion.view';
import StoreSpecialMsg from './StoreSpecialMsg';
import ReviewAndratings from './ReviewAndratings';
import style, { ColorSwatchWrapper, PlpTile } from './styles/PlpTile.style';
import InfluencerBadgeHandle from '../../../../common/atoms/InfluencerBadgeHandle/view/InfluencerBadgeHandle';
import { memoizeTileData } from './plpTileHelpers/cacheHelper';
import { featureBrandTileAttribute } from '../../SearchDetail/container/SearchDetail.constants';

// eslint-disable-next-line sonarjs/cognitive-complexity
function SlpTileView(props) {
  const {
    bestSellerBadgeLabel,
    topRatedBadgeLabel,
    mostFavoritedBadgeLabel,
    pickupInStore,
    shopTheLook,
    shopCollection,
    pointsAndRewardsText,
  } = getSLPTileLabels();
  const {
    className,
    pathName = '',
    slpTileData,
    tileActions,
    wishListData,
    submitButtonText,
    isBrierleyPromoEnabled,
    promotionsData = {},
    trackClickPromotion,
    serverTime,
    isBuyMorePromoEnabled,
    isLoggedIn,
    trackWishListClick,
    isPlcc,
    isInternationalShipping,
    isTopRatedBadgeEnabledSLP,
    isBestSellerBadgeEnabledSLP,
    isNewSwatchUrlEnabled,
    preloadImage,
    isBopisFilterOn,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    isMostFavoritedBadgeEnabled,
    setPLPSLPAddToCartCTA,
    isInfluencerBadgeEnabled,
    isTileRedesignAB,
    isInfluencerPicksEnabled,
    favAddRemoveLoadingState,
    isAlternateImageOnHoverEnabled,
    isShowPriceRangeEnabled,
    isUpdatedPromotionsDisplayEnabled,
    imageConfigWithoutDPR = '',
    topRatedAttributeSLP,
    bestSellerAttributeSLP,
    mostFavoritedAttributeSLP,
    acrossBrandApiCalled,
    resetSlpLoadingState,
    searchQuery,
    alternateBrandsShown,
    position,
    currency,
    saveProductDataForQV,
    saveProductDataForPdp,
    isDynamicColorSwatchesEnabled,
    isHoverToPreviewColorSwatchesEnabled,
    isInteractiveColorSwatchBandEnabled,
    isSwatchAsColorUrlEnabled,
    isHoverToRevealATBButtonEnabled,
    isFeatureBrandEnabled,
    isFinalSaleABEnabled,
    isRandomBgColorEnabled,
    isDynamicBadgeEnabled,
    isDynamicBadgeEnabledAbtest,
    isFadeImageHoverEnabled,
    isTransparentImageSizeReduceEnabled,
  } = props;
  const hasMounted = useHasMounted();

  const isMountedTileRedesignAB = getMountedTileRedesignVariation(hasMounted, isTileRedesignAB);

  const {
    prodpartno: productPartNo,
    style_partno: stylePartNo,
    seo_token: seoToken,
    product_name: productName,
    min_list_price: minLP,
    min_offer_price: minOP,
    low_offer_price: lowOfferPrice,
    high_offer_price: highOfferPrice,
    TCPSwatchesUSStore,
    low_list_price: lowListPrice,
    high_list_price: highListPrice,
    TCPSwatchesCanadaStore,
    TCPBazaarVoiceRating,
    alt_img: altImage,
    TCPBazaarVoiceReviewCount,
    productimage: imageName,
    TCPStyleQTYCA,
    TCPStyleQTYUS,
    TCPLoyaltyPromotionTextUSStore: promotionalMessage,
    TCPStyleTypeCA,
    TCPStyleTypeUS,
    TCPLoyaltyPLCCPromotionTextUSStore: promotionalPLCCMessage,
    swatchimage: swatchImg,
    related_product_swatch_images: relatedSwatches,
    TCPColor: tcpColor,
    auxdescription: auxDescription,
    store_specials: storeSpecial,
    TCPCustomSalePrice,
    TCPCustomListPrice,
    tcp_promotion_id: TCPPromotionID,
    tcp_promo_price: TCPPromotionPrice,
    productid,
  } = slpTileData;

  const TCPProductIndStore = !isCanada()
    ? extractAttributeValue(slpTileData, 'TCPProductIndUSStore')
    : extractAttributeValue(slpTileData, 'TCPProductIndCanadaStore');
  const { isDesktop } = getViewportInfo() || {};
  let isMountedInteractiveColorSwatchBandEnabled = false;
  if (hasMounted && isDesktop && isInteractiveColorSwatchBandEnabled) {
    isMountedInteractiveColorSwatchBandEnabled = true;
  }

  const isMountedHoverToRevealATBButtonEnabled = getIsMountedHoverToRevealATBButtonEnabled({
    isHoverToRevealATBButtonEnabled,
    hasMounted,
    isDesktop,
  });

  const TCPPrimaryCategory = getTCPPrimaryCategory(slpTileData);
  const topRatedSLP = extractAttributeValue(slpTileData, topRatedAttributeSLP);
  const bestSellerSLP = extractAttributeValue(slpTileData, bestSellerAttributeSLP);
  const mostFavoritedSLP = extractAttributeValue(slpTileData, mostFavoritedAttributeSLP);
  const featureBrand =
    isFeatureBrandEnabled && extractAttributeValue(slpTileData, featureBrandTileAttribute);
  slpTileData.TCPPrimaryCategory = TCPPrimaryCategory;
  const { minListPrice, minOfferPrice } = calculateMinPrices(
    TCPCustomListPrice,
    minLP,
    TCPCustomSalePrice,
    minOP
  );
  const styleTypeQty = {
    TCPStyleQTYCA,
    TCPStyleQTYUS,
    TCPStyleTypeCA,
    TCPStyleTypeUS,
  };
  const relatedSwatchImages = getRelatedSwatches(relatedSwatches);
  const isHardMarkDown = slpTileData?.is_hard_mark_enable;
  const isHideOriginalPrice = hideProductOriginalPrice(
    isHardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled
  );
  const { onQuickViewOpenClick, onAddItemToFavorites, onSetLastDeletedItemIdAction, addToBagEcom } =
    tileActions;
  const isBundle = isBundleProduct(slpTileData);
  const commonCacheKeys = { pathName, productId: productPartNo };
  const tileBadges = memoizeTileData(
    getPlpTileBadges,
    { ...commonCacheKeys, key: 'badges' },
    {
      tileData: slpTileData,
      categoryName: '',
      bestSellerBadgeLabel,
      topRatedBadgeLabel,
      mostFavoritedBadgeLabel,
      isBundleProduct: isBundle,
    }
  );
  const { extendedSizes, topBadge, merchantTag, zoneOneBadges, zoneSixBadges } = tileBadges;
  const apiConfig = getAPIConfig();
  const { brandId: primaryBrand, siteId } = apiConfig;
  const brand = memoizeTileData(
    getPlpProductBrand,
    { ...commonCacheKeys, key: 'brand' },
    slpTileData,
    primaryBrand
  );
  const { pdpUrl } = getPdpUrlWithAlternateBrandSLP({
    seoToken,
    siteId,
    productPartNo,
    isBundleProduct: isBundle,
    TCPPrimaryCategory,
    alternateBrand: getAlternateBrand({
      acrossBrandApiCalled,
      brand: alternateBrandsShown,
      primaryBrand,
    }),
  });
  const TCPSwatches = getSwatches(siteId, TCPSwatchesUSStore, TCPSwatchesCanadaStore);
  const productStyleType = TCPStyleQTYUS || TCPStyleQTYCA;

  const { assetHost, assetPath } = getImageAssetConfig(brand, apiConfig);
  const assetHostBaseUrl = extractBaseUrl(assetHost);
  const influencerTags = getInfluencerTags(slpTileData);
  const influencerPicks = getInfluencerPicks(slpTileData);
  const influencerPickToDisplay = getInfluencersPickToDisplay({
    isInfluencerPicksEnabled,
    influencerPicks,
  });

  const topRatedBadge = getBadgeLabels(isTopRatedBadgeEnabledSLP, topRatedSLP, topRatedBadgeLabel);
  const bestSellerBadge = getBadgeLabels(
    isBestSellerBadgeEnabledSLP,
    bestSellerSLP,
    bestSellerBadgeLabel
  );
  const mostFavoritedBadge = getBadgeLabels(
    !isMostFavoritedBadgeEnabled,
    mostFavoritedSLP,
    mostFavoritedBadgeLabel
  );

  const zoneOneBadgesArray = getZoneOneBadgesArray({
    zoneOneBadges,
    topRatedBadge,
    bestSellerBadge,
    mostFavoritedBadge,
    influencerPickToDisplay,
  });

  const { imageUrl, itemAvailability, isVideoUrl, fullImageUrl, overlayBadgeParams } = getImageData(
    {
      stylePartNo,
      productPartNo,
      assetPath,
      imageName,
      altImage,
      primaryBrand,
      assetHostBaseUrl,
      ...styleTypeQty,
      isDynamicBadgeEnabledAbtest,
    }
  );
  const [newImageUrl, setNewImageUrl] = useState(imageUrl);
  const [hoverImageUrl, setHoverImageUrl] = useState(null);
  const [orgImageUrl, setOrgImageUrl] = useState(imageUrl);

  useEffect(() => {
    setNewImageUrl(imageUrl);
  }, [imageUrl]);

  useEffect(() => {
    try {
      let productImage = null;

      if (altImage) {
        const altImageParsed = JSON.parse(altImage);
        productImage = altImageParsed?.[productPartNo]?.split(',')[0] || null;
      }

      if (productImage) {
        const tempImageUrl = `${assetPath}/${stylePartNo}/${productImage}`;
        setHoverImageUrl(tempImageUrl);
      } else {
        setHoverImageUrl(null); // fallback if nothing found
      }
    } catch (err) {
      logger.error(err);
      setHoverImageUrl(null);
    }
  }, [altImage, productPartNo, assetPath, stylePartNo, isAlternateImageOnHoverEnabled]);

  const isSwatchFeatureActive = (swatchId) => {
    const isSwatchIdPresent = Boolean(swatchId);
    const isFeatureEnabled =
      isHoverToPreviewColorSwatchesEnabled || isInteractiveColorSwatchBandEnabled;

    return isSwatchIdPresent && isFeatureEnabled;
  };

  const collectProductDataOnClick = (swatchId = '') => {
    const uniqueIdProduct = slpTileData?.uniqueId || '';
    const isSwatchIdProvided = isSwatchFeatureActive(swatchId);

    let updateImageURL = imageUrl;
    let updateFullImageURL = fullImageUrl;
    let stylePartNoUpdated = stylePartNo;
    if (isSwatchIdProvided) {
      stylePartNoUpdated = swatchId.split('_');
      updateImageURL = imageUrl?.replace(uniqueIdProduct, swatchId);
      updateImageURL = updateImageURL?.replace(stylePartNo, stylePartNoUpdated[0]);
      updateFullImageURL = fullImageUrl?.replace(uniqueIdProduct, swatchId);
      updateFullImageURL = updateFullImageURL?.replace(stylePartNo, stylePartNoUpdated[0]);
    }

    const updatedTileData = {
      ...slpTileData,
      uniqueId: isSwatchIdProvided ? swatchId : uniqueIdProduct,
      stylePartNo: isSwatchIdProvided ? stylePartNoUpdated[0] : stylePartNo,
      zoneOneBadgesArray,
    };
    return getProductDataForPdp({
      topBadge,
      styleTypeQty,
      primaryBrand: brand,
      productImageUrl: updateImageURL,
      tileData: updatedTileData,
      downloadedImage: updateFullImageURL,
      merchantTag,
      isBundle,
      promotionsData,
      TCPSwatches,
      imageConfigWithoutDPR,
    });
  };

  const setProductDataForPdp = (fromProductImage) => {
    const pdpData = collectProductDataOnClick();
    saveProductDataForPdp(pdpData);

    updateGoogleAnalyticsData({
      shouldTriggerAnalyticsCall: fromProductImage,
      page: 'search',
      offerPrice: minOfferPrice,
      listPrice: minListPrice,
      searchQuery,
      position,
      currency,
      isHideOriginalPriceAndMarchantTagEnabled,
      tileData: slpTileData,
    });
  };

  const saveDataForQv = (swatchId = '') => {
    const quickViewData = collectProductDataOnClick(swatchId);
    saveProductDataForQV(quickViewData);
    callAnalyticsOnAddToBagclick({
      productId: productid,
      page: 'search',
      acrossBrandApiCalled,
      alternateBrandsShown,
      searchQuery,
      offerPrice: minOfferPrice,
      productName,
    });
  };

  const handleViewBundleClick = () => {
    const { href, asPathWithoutSlug } = pdpUrl;
    routerPush(href, asPathWithoutSlug);
  };

  const handleHoverOnColorSwatch = (id) => {
    const imageNameExtension = imageName?.split('.')[1] || 'png';
    if (!id) return;

    const tempImageUrl = `${assetPath}/${id.split('_')[0]}/${id}.${imageNameExtension}`;

    if (isFadeImageHoverEnabled) {
      setOrgImageUrl(tempImageUrl);
    } else {
      setNewImageUrl(tempImageUrl);
    }
  };

  const handleClick = () => {
    handleClickFunc({
      isBundle,
      handleViewBundleClick,
      setProductDataForPdp,
      tileData: slpTileData,
      isOneClickATCEnabled,
      isBopisFilterOn,
      topBadge,
      brand,
      imageUrl,
      addToBagEcom,
      saveDataForQv,
      onQuickViewOpenClick,
      productPartNo,
      acrossBrandApiCalled,
      resetSlpLoadingState,
      alternateBrandsShown,
    });
  };

  const handleMouseEnter = () => {
    handleMouseEnterImage(
      altImage,
      productPartNo,
      isAlternateImageOnHoverEnabled,
      assetPath,
      stylePartNo,
      setNewImageUrl
    );
  };

  const handleMouseLeave = () => {
    handleMouseLeaveImage({
      newImageUrl,
      imageUrl,
      orgImageUrl,
      setNewImageUrl,
      setOrgImageUrl,
      isAlternateImageOnHoverEnabled,
      isHoverToPreviewColorSwatchesEnabled,
      isFadeImageHoverEnabled,
    });
  };

  return (
    <PlpTile
      data-prodId={productPartNo}
      className={`${className} slp-tile`}
      {...getTileHoverProps({
        isMountedInteractiveColorSwatchBandEnabled,
        handleMouseEnter,
        handleMouseLeave,
      })}
    >
      <div className={`flex-row justify-between`}>{renderBadge({ zoneOneBadgesArray })}</div>
      <div
        className={`relative${getInteractiveColorSwatchesClass(
          isMountedInteractiveColorSwatchBandEnabled
        )}`}
      >
        <ProductImage
          key={`pti-${productPartNo}`}
          itemAvailability={itemAvailability}
          fullImageUrl={fullImageUrl}
          pdpUrl={pdpUrl}
          productName={productName}
          isVideoUrl={isVideoUrl}
          pathName={pathName}
          setProductDataForPdp={setProductDataForPdp}
          imageConfigWithoutDPR={imageConfigWithoutDPR}
          imageUrl={newImageUrl}
          orgImageUrl={orgImageUrl}
          hoverImageUrl={hoverImageUrl}
          assetHostBaseUrl={assetHostBaseUrl}
          overlayBadgeParams={overlayBadgeParams}
          topRatedBadge={topRatedBadge}
          bestSellerBadge={bestSellerBadge}
          mostFavoritedBadge={mostFavoritedBadge}
          preloadImage={preloadImage}
          isMountedTileRedesignAB={isMountedTileRedesignAB}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          isSLPTile
          isMountedInteractiveColorSwatchBandEnabled={isMountedInteractiveColorSwatchBandEnabled}
          handleHoverOnColorSwatch={handleHoverOnColorSwatch}
          productPartNo={productPartNo}
          TCPSwatches={TCPSwatches}
          onQuickViewOpenClick={onQuickViewOpenClick}
          assetHost={assetHost}
          assetPath={assetPath}
          saveDataForQv={saveDataForQv}
          swatchImg={swatchImg}
          tcpColor={tcpColor}
          auxDescription={auxDescription}
          relatedSwatchImages={relatedSwatchImages}
          isBundleProduct={isBundle}
          handleViewBundleClick={handleClick}
          isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
          productIndex={position}
          isRandomBgColorEnabled={isRandomBgColorEnabled}
          isDynamicBadgeEnabled={isDynamicBadgeEnabled}
          isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
          isFadeImageHoverEnabled={isFadeImageHoverEnabled}
          isTransparentImageSizeReduceEnabled={isTransparentImageSizeReduceEnabled}
        />
        <InfluencerBadgeHandle
          isAbOn={isInfluencerBadgeEnabled}
          influencerTags={influencerTags}
          image={imageName}
          isPreviewImage
        />
        <Wishlist
          wishListData={wishListData}
          productName={productName}
          productPartNo={productPartNo}
          onAddItemToFavorites={onAddItemToFavorites}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          primaryBrand={primaryBrand}
          trackWishListClick={trackWishListClick}
          isLoggedIn={isLoggedIn}
          isBundle={isBundle}
          favAddRemoveLoadingState={favAddRemoveLoadingState}
          isSLPTile
        />
      </div>
      {!isMountedInteractiveColorSwatchBandEnabled && (
        <ColorSwatchWrapper isTileRedesignAB={isTileRedesignAB} isPlp>
          {renderColorSwatches({
            productPartNo,
            TCPSwatches,
            onQuickViewOpenClick,
            assetHost,
            assetPath,
            saveDataForQv,
            swatchImg,
            tcpColor,
            auxDescription,
            relatedSwatchImages,
            isBundle,
            handleClick,
            isNewSwatchUrlEnabled,
            isMountedTileRedesignAB,
            isDynamicColorSwatchesEnabled,
            isHoverToPreviewColorSwatchesEnabled,
            handleHoverOnColorSwatch,
            handleMouseLeave,
            productStyleType,
            isSwatchAsColorUrlEnabled,
          })}
        </ColorSwatchWrapper>
      )}
      {hasMounted && setPLPSLPAddToCartCTA !== 'off' ? (
        <div className={`flex-row justify-between atb-icon-parent`}>
          <Price
            minListPrice={minListPrice}
            minOfferPrice={minOfferPrice}
            lowOfferPrice={lowOfferPrice}
            highOfferPrice={highOfferPrice}
            lowListPrice={lowListPrice}
            highListPrice={highListPrice}
            productPartNo={productPartNo}
            merchantTag={merchantTag}
            onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
            primaryBrand={primaryBrand}
            isLoggedIn={isLoggedIn}
            isBundle={isBundle}
            isHideOriginalPrice={isHideOriginalPrice}
            setPLPSLPAddToCartCTA={setPLPSLPAddToCartCTA}
            isShowPriceRangeEnabled={isShowPriceRangeEnabled}
            isTileRedesignAB={isMountedTileRedesignAB}
          />
          {setPLPSLPAddToCartCTA === 'icon' && (
            <AtbIcon
              onClick={async () => {
                await AddedtoBagDynamicStore();
                handleClick();
              }}
              className="floating-atb-btn"
            >
              <img
                className="atb-icon-image"
                src={getIconPath('add-to-bag-icon-blue')}
                alt="Add to bag"
              />
            </AtbIcon>
          )}
        </div>
      ) : (
        <PriceAndWishList
          minListPrice={minListPrice}
          minOfferPrice={minOfferPrice}
          lowOfferPrice={lowOfferPrice}
          highOfferPrice={highOfferPrice}
          lowListPrice={lowListPrice}
          highListPrice={highListPrice}
          productPartNo={productPartNo}
          merchantTag={merchantTag}
          wishListData={wishListData}
          onAddItemToFavorites={onAddItemToFavorites}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          primaryBrand={primaryBrand}
          trackWishListClick={trackWishListClick}
          isLoggedIn={isLoggedIn}
          isBundle={isBundle}
          isHideOriginalPrice={isHideOriginalPrice}
          isPLP
          isSLPTile
          isShowPriceRangeEnabled={isShowPriceRangeEnabled}
          isTileRedesignAB={isMountedTileRedesignAB}
          setPLPSLPAddToCartCTA={setPLPSLPAddToCartCTA}
        />
      )}
      {promotionsData[TCPPromotionID] && (
        <PromotionView
          promotionsData={promotionsData}
          showIcon={false}
          trackClickPromotion={trackClickPromotion}
          serverTime={serverTime}
          className={'isPLP isSLPTile'}
          pageName={'SLP'}
          brand={brand}
          isBuyMorePromoEnabled={isBuyMorePromoEnabled}
          isTileRedesignAB={isTileRedesignAB}
          TCPPromotionPrice={TCPPromotionPrice}
          TCPPromotionID={TCPPromotionID}
          isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
        />
      )}
      <ProductTitleAndBrand
        itemAvailability={itemAvailability}
        productName={productName}
        brand={brand}
        primaryBrand={primaryBrand}
        pdpUrl={pdpUrl}
        pathName={pathName}
        setProductDataForPdp={setProductDataForPdp}
        isTileRedesignAB={isTileRedesignAB}
        extendedSizes={extendedSizes}
        isBundle={isBundle}
        isMountedTileRedesignAB={isMountedTileRedesignAB}
        isSLPTile
        featureBrand={featureBrand}
      />
      {renderPointsAndPromotion({
        isBrierleyPromoEnabled,
        pointsAndRewardsText,
        promotionalMessage,
        promotionalPLCCMessage,
        isPlcc,
        isInternationalShipping,
      })}
      <ReviewAndratings
        TCPBazaarVoiceRating={TCPBazaarVoiceRating}
        TCPBazaarVoiceReviewCount={TCPBazaarVoiceReviewCount}
        isTileRedesignAB={isMountedTileRedesignAB}
      />
      {renderZoneSixBadges({ zoneSixBadges, isFinalSaleABEnabled, TCPProductIndStore })}
      <StoreSpecialMsg
        offerPrice={minOfferPrice}
        isStoreSpecialEligible={parseBoolean(storeSpecial)}
        TCPPromotionPrice={TCPPromotionPrice}
        TCPPromotionID={TCPPromotionID}
      />
      {(!hasMounted || setPLPSLPAddToCartCTA === 'off') &&
        renderSubmitButton({
          isBundle,
          submitButtonText,
          pickupInStore,
          primaryBrand,
          shopTheLook,
          shopCollection,
          handleClick,
          hasMounted,
          isMountedHoverToRevealATBButtonEnabled,
        })}
    </PlpTile>
  );
}
export { SlpTileView as SlpTileViewVanilla };
export default withStyles(SlpTileView, style);
